export var fadeInHeight = {
    hide: {
        opacity: 0,
        height: "0"
    },
    show: {
        opacity: 1,
        height: "auto"
    }
};

//# sourceMappingURL=fadeInHeight.js.map